const styles = theme => ({
  root: { display: 'flex', width: '100%', padding: 20, backgroundColor: 'transparent' },
  label: { fontSize: 18, marginBottom: 10 },
  // formControl: { 'margin-top': theme.spacing.unit },
  group: {
    'flex-direction': 'row',
    '-ms-flex-direction': 'row',
    backgroundColor: theme.palette.background.paper,
    padding: 20,
  },
  checked: { color: '#2974FF !important' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/meals/mealSwitch/MealSwitchStyles.js